<template>
    <section class="c-security-why-quarkino">
        <y-loading
            v-if="!securityContent"
            :active="$wait.is('loading-security-section')"
            size="60"
            height="467px"
            position="relative"
        />
        <div
            v-else
            class="c-security-why-quarkino--loaded"
        >
            <div class="c-security-why-quarkino__wrapper">
                <h2 class="c-security-why-quarkino__title">
                    {{ securityContent.title }}
                </h2>
                <div class="c-security-why-quarkino__box-wrapper">
                    <div class="c-security-why-quarkino__double-box">
                        <div class="c-security-why-quarkino__box--blue box">
                            <h3 class="c-security-why-quarkino__box--title">
                                {{ securityContent.custom.field1 }}
                            </h3>
                            <p class="c-security-why-quarkino__box--description">
                                {{ securityContent.custom.field2 }}
                            </p>
                        </div>

                        <div class="c-security-why-quarkino__box--yellow box">
                            <h3 class="c-security-why-quarkino__box--title">
                                {{ securityContent.custom.field3 }}
                            </h3>
                            <p class="c-security-why-quarkino__box--description">
                                {{ securityContent.custom.field4 }}
                            </p>
                        </div>
                    </div>
                    <div class="c-security-why-quarkino__picture-box">
                        <div class="c-security-why-quarkino__pictures">
                            <img
                                v-for="brand in securityContent.albums"
                                :key="brand.id"
                                :src="brand.link"
                                :alt="brand.title"
                            >
                        </div>
                        <h3 class="c-security-why-quarkino__picture-box--title">
                            {{ securityContent.custom.field5 }}
                        </h3>
                        <p class="c-security-why-quarkino__picture-box--description">
                            {{ securityContent.custom.field6 }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="securityContent.custom">
                <y-call-to-action :content="securityContent.custom" />
            </div>
        </div>
    </section>
</template>

<script >

    // Components
    import YCallToAction from '@modules/why-quarkino/components/CallToAction/Index.vue';

    export default {
        name: 'WhyQuarkinoSecurity',

        components: {
            YCallToAction,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                securityContent: null,
            };
        },

        /**
         * @inheritDoc
         */
        created() {
            this.fetch();
        },

        /**
         * @inheritDoc
         */
        methods: {

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-security-section');
                const features = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'why-quarkino-security',
                    including: ['title', 'custom', 'albums', 'title2'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([features])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.securityContent = responses[0].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-security-section');
                    });
            },
        },
    };

</script>

<style lang="scss" src="./security.scss"/>
